import { addScriptToHeader, linkScriptToHeader } from "@utilize/Init";

export interface IAnalytics {
    init: (code?: string) => void;
    // pageview: (path: string, title?: string) => void;
}

export const Analytics: IAnalytics = () => { };

Analytics.init = (code: string = "") => {
    linkScriptToHeader(`https://www.googletagmanager.com/gtag/js?id=${code}`);
    const text = `
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', '${code}');
    `;
    addScriptToHeader(text);
}

// Analytics.pageview = (path: string, title: string = "") => {
//     window.gtag("config", `'${Config.config.gAnalyticsCode}'`, {
//         'page_path': path,
//         'page_title': title
//     })
// }